import { IconButtonProps } from "@rjsf/utils";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export const AddButton = (props: IconButtonProps & { label?: string }) => {
  const { onClick, disabled, label } = props;
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<AddIcon />}
      variant="contained"
      color="primary"
      size="small"
      sx={{ mt: 2, mb: 1, textTransform: 'none' }}
    >
      {label || "Add Item"}
    </Button>
  );
};

export const RemoveButton = (props: IconButtonProps) => {
  const { onClick, disabled } = props;
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<DeleteIcon />}
      variant="contained"
      color="error"
      size="small"
      sx={{ ml: "auto" }}
    >
      Remove Item
    </Button>
  );
};
